export class TemplateHtml {
  public code: string = null;
  public html: string = null;
}
